import { render, staticRenderFns } from "./Basic2.vue?vue&type=template&id=28cf8418&scoped=true&"
import script from "./Basic2.vue?vue&type=script&lang=js&"
export * from "./Basic2.vue?vue&type=script&lang=js&"
import style0 from "./Basic2.vue?vue&type=style&index=0&id=28cf8418&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28cf8418",
  null
  
)

export default component.exports